/* Below order of css imports is important
    1. Bootstrap css
    2. App.css (imported AFTER bootstrap css to override bootstrap css if required)
    3. Component css (if any - to override App.css if required)
  */
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.css";
import React, {useEffect} from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import GuestLoginScreen from "./screens/GuestLoginScreen";
import GuestUserHomeScreen from "./screens/GuestUserHomeScreen";
import BackOfficeScreen from "./screens/BackOfficeScreen";
import BackOfficeLogin from "./screens/BackOfficeLogin";
import BORoute from "./components/BORoute";
import BackOfficeAdminRegister from "./screens/BackOfficeAdminRegister";
import {setupAxiosInterceptors} from "./services/AxiosConfigService";
import RegisteredLoginScreen from "./screens/RegisteredLoginScreen";
import RegisteredHomeScreen from "./screens/RegisteredHomeScreen";
import RegisteredRoute from "./components/RegisteredRoute";
import RegUserRegisterScreen from "./screens/RegUserRegisterScreen";
import RegAccountVerificationSuccessScreen from "./screens/RegAccountVerificationSuccessScreen";
import RegResetPasswordExecuteScreen from "./screens/RegResetPasswordExecuteScreen";
import GlobalIdleManager from "./components/GlobalIdleManager";
import {useDispatch} from "react-redux";
import {validateRegisteredSession} from "./actions/registeredUserAction";
import { checkVersionAndReload } from "./versionCheck";

// Initialize axios interceptors
setupAxiosInterceptors();

const App = ({ history }) => {

  const dispatch = useDispatch();

  // Check for outdated front end and reload if needed
  useEffect(() => {
    checkVersionAndReload();
  }, []);

  useEffect(() => {
    // Try to validate and refresh a persisted registered user session on app startup
    dispatch(validateRegisteredSession());
  }, [dispatch]);

  return (
    <div className="gcotg-top-level-app">
      <Router history={history}>
        <GlobalIdleManager />
        <Switch>
          <Route path="/" component={GuestLoginScreen} exact />
          <Route path="/userhome/:id" component={GuestUserHomeScreen} />
          <Route path="/userregister" component={RegUserRegisterScreen} />
          <Route path="/registeredlogin" component={RegisteredLoginScreen} />
          <Route path="/accountverificationsuccess" component={RegAccountVerificationSuccessScreen} />
          <Route path="/resetpasswordexecute" component={RegResetPasswordExecuteScreen} />
          <RegisteredRoute path="/homepage" component={RegisteredHomeScreen} />
          <Route path="/bologin" component={BackOfficeLogin} />
          <Route path="/boregister" component={BackOfficeAdminRegister} />
          <BORoute path="/backoffice" component={BackOfficeScreen} />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
